/* DSL Cart persistence — bewaar cart-snapshot 7 dagen voor abandonment-emails */
(function(){
  var KEY = "dsl_cart_snapshot";
  function save(){
    fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
      try { localStorage.setItem(KEY, JSON.stringify({c:c, ts: Date.now()})); } catch(e){}
    }).catch(function(){});
  }
  function load(){
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (Date.now() - d.ts > 7*86400e3) { localStorage.removeItem(KEY); return null; }
      return d.c;
    } catch(e){ return null; }
  }
  document.addEventListener("DOMContentLoaded", save);
  document.addEventListener("dsl:cart:change", save);
  window.DSL_CART_PERSIST = {save: save, load: load};
})();